import React from "react"
import RedirectComp from "../../components/Authorization/redirect";

export default function AuthorizationRedirect() {
    return (
            <RedirectComp/>
    )
}
